import _ from "lodash";

TitlesMainGridController.$inject = [
  "TitlesMainGridDataSource",
  "$state",
  "angularGridTemplates",
  "userProfile",
  "userServer",
  "$window",
];
function TitlesMainGridController(
  TitlesMainGridDataSource,
  $state,
  angularGridTemplates,
  userProfile,
  userServer,
  $window
) {
  var vm = this;

  var columnDefs = [
    {
      colId: "edit",
      headerName: "",
      width: 20,
      template: angularGridTemplates.edit("ctrl.edit(data)"),
      editable: false,
      suppressMenu: true,
      suppressSorting: true,
    },
    { headerName: "Name", field: "Name", editable: false, suppressMenu: true },

    {
      colId: "deleteTitle",
      headerName: "Action",
      editable: false,
      suppressMenu: true,
      suppressSorting: true,
      template:
        '<div class="btn btn-danger" ng-click="ctrl.deleteTitle(data)">Delete</div>',
    },
  ];

  columnDefs = _.filter(columnDefs, function (columnDef) {
    var permission = columnDef.requiresPermission;
    return permission === undefined || userProfile.hasPermission(permission);
  });

  vm.gridOptions = {
    enableServerSideSorting: true,
    enableServerSideFilter: true,
    columnDefs: columnDefs,
    enableColResize: true,
    angularCompileRows: true,
    rowHeight: 40,
    rowSelection: "multiple",
  };

  var defaultQuery = {};

  vm.query = _.assign({}, defaultQuery);
  vm.filterChanged = refreshData;
  vm.clearFilters = clearFilters;

  vm.gridOptions.datasource = new TitlesMainGridDataSource(
    vm.query,
    vm.gridOptions
  );
  vm.edit = edit;
  vm.deleteTitle = deleteTitle;

  function refreshData() {
    vm.gridOptions.api.setDatasource(
      new TitlesMainGridDataSource(vm.query, vm.gridOptions)
    );
  }

  function clearFilters() {
    vm.query = _.assign({}, defaultQuery);
    refreshData();
  }



  function edit(title) {
    $state.go("^.edit", {
      title: title,
    });
  }

  function deleteTitle(title) {
    userServer.deleteTitle(title.Id).then(
      function success() {
        refreshData();
      },
      function error(error) {
        $window.alert(error.data.ResponseStatus.Message);
      }
    );
  }
}
export default TitlesMainGridController;
